module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-index"
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6), _vm._m(7), _vm._m(8), _vm._m(9), _vm._m(10), _vm._m(11), _vm._m(12), _vm._m(13), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": require("assets/goTop.png")
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-swiper"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/swiper1.png")
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/swiper2.png")
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/swiper3.png")
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/swiper4.png")
    }
  })])])]), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/index/img1.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand-desc"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝相信，家的样子，不应被任何风格所具象定义。")]), _c('div', {
    staticClass: "line3"
  }, [_vm._v("我们甄选有人性温度的好设计，以不过度张扬的生活审美、长久陪伴的细腻品质，"), _c('br'), _vm._v("为你的家一点一点增添动人温情，打造属于自己的理想生活。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module1"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("真正贴近用户的甄选"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("我们的每一件产品都经过专业选品团队反复对比甄选，力求设计、品质、性价比、功能和舒适度等维度的平衡。"), _c('br')]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("与此同时，基于对欧美市场的调研及对国内消费者的家居审美与使用偏好的观察，我们综合权衡每个品类、每件产品"), _c('br'), _vm._v("的款式、风格与价格，力求将最优的选择呈现给对家居审美有追求的客户，让大家挑选过程更加从容。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module2"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": require("assets/index/img4.png")
    }
  }), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("品位设计，生活之审美")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("我们放眼全球搜罗精良产品，不盲目追随前卫和潮流，但也拒绝平庸审美，希望能用恰到好处的设计感，满足真实生活的需求与审美。")])])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": require("assets/index/img5.png")
    }
  }), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("严控工艺，兼具品质与舒适")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("高品质与舒适度是我们选品的重要标准。懂窝所合作的国内外一线工厂，拥有稳定精良的质量把控体系。")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("每一件产品在出厂前，都经过材质、工艺、体验等方面反复检验与测试，懂窝选品团队更是对实物进行逐一体验，确保坐感或触感等各方面具备令人满意的舒适度。")])])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": require("assets/index/img6.png")
    }
  }), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("源头直采，物超所值")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("在确保品质与舒适的同时，我们尽量控制成本，追求性价比。")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("专业买手深入供应链上游直采，从工厂直接到消费者，省去了品牌商、代理商、经销商等层层溢价，同时采用无库存敏捷供应链，优化运营效率与缩减成本，充分让客户感到物超所值。")])])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": require("assets/index/img7.png")
    }
  }), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("多元风格，可混搭融合")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("我们的产品涵盖："), _c('br'), _vm._v("复古轻奢、粗犷工业、质朴原木、 现代北欧、当代摩登等多种风格。"), _c('br'), _vm._v("满足更多追求家居审美人群的喜好与需求。同时力求产品之间可以相互混搭，即便风格各异也毫不突兀。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module3"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("有人性温度的好设计"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝通过探索现代人居家生活，"), _c('br'), _vm._v("结合性格型态学，糅炼出"), _c('br'), _vm._v("「＋骛美」、「－物然」、「×质想」、「÷颜趣」四个产品系列。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module4"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": require("assets/index/img27.png")
    }
  }), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "icon"
  }, [_vm._v("➕")]), _c('div', {
    staticClass: "subTitle"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("骛美")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("Aesthetic")])])]), _c('div', {
    staticClass: "desc"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("更追求设计感的领袖家")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("渴望有序而规律"), _c('br'), _vm._v("充满设计感的家具"), _c('br'), _vm._v("带来更多安静与祥和")])])])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": require("assets/index/img28.png")
    }
  }), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "icon"
  }, [_vm._v("➖")]), _c('div', {
    staticClass: "subTitle"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("物然")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("Practicality")])])]), _c('div', {
    staticClass: "desc"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("着重实用体验的生活家")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("渴望随遇而安的笃定"), _c('br'), _vm._v("给家更多温暖与实用"), _c('br'), _vm._v("是你触手可及的幸福。")])])])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": require("assets/index/img29.png")
    }
  }), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "icon"
  }, [_vm._v("✖️")]), _c('div', {
    staticClass: "subTitle"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("质想")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("Quality")])])]), _c('div', {
    staticClass: "desc"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("专享细腻品质的思考家")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("喜欢独立思考"), _c('br'), _vm._v("坚持能深得你心的"), _c('br'), _vm._v("一定是经得起时间考验的")])])])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": require("assets/index/img30.png")
    }
  }), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "icon"
  }, [_vm._v("➗")]), _c('div', {
    staticClass: "subTitle"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("颜趣")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("Fun")])])]), _c('div', {
    staticClass: "desc"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("敢尝有颜有趣的探索家")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("好看皮囊和有趣的灵魂都想要"), _c('br'), _vm._v("只有新鲜材质与趣意设计"), _c('br'), _vm._v("才能彰显你的与众不同")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module5"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("产品品质源于品质工厂"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝所合作的家具家居工厂，均为国际一线家居品牌的源头制造商。"), _c('br'), _vm._v("工艺及环保标准符合欧美国家的进口标准。"), _c('br'), _vm._v("我们致力于将品质家具的优质体验，呈现给每一位懂窝的用户。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module6"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("知名家具源头制造商")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("30多年家具制造经验，HAY、Bo Concept、圣奥、顾家"), _c('br'), _vm._v("等众多国内外知名品牌源头制造商。")])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("实力家具外贸工厂")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("产品95％用于海外市场，"), _c('br'), _vm._v(" MADE.com、5 Horizon GroupPT Home "), _c('br'), _vm._v("Center、Castlery等国外知名电商及家具平台合作商。")])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("国内知名沙发制造商")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("33年家具制造经验，产品远销法国、英国、俄罗斯、美"), _c('br'), _vm._v("国、加拿大等三十多个国家和地区。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module7"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("售卖产品 更是服务"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("每一位懂窝客户都将获得贴心周到的服务，至您踏入懂窝门店或与我们客服联系的那刻起，您将获得——专业的售"), _c('br'), _vm._v("前咨询服务、软装搭配服务、免费送货安装服务和及时响应的售后服务，让您整个家具购买体验顺畅而安心。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module8"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/iocn1.png")
    }
  }), _c('p', [_vm._v("3年"), _c('br'), _vm._v("质量保障")])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/iocn2.png")
    }
  }), _c('p', [_vm._v("免费"), _c('br'), _vm._v("送货上门")])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/iocn3.png")
    }
  }), _c('p', [_vm._v("免费"), _c('br'), _vm._v("专业安装")])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/iocn4.png")
    }
  }), _c('p', [_vm._v("提前预定"), _c('br'), _vm._v("免费仓储")])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/iocn5.png")
    }
  }), _c('p', [_vm._v("7天"), _c('br'), _vm._v("无理由退换")])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/iocn6.png")
    }
  }), _c('p', [_vm._v("开具"), _c('br'), _vm._v("正规发票")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module9"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("不同渠道 相同体验"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("我们致力于打造线上线下全品类场景化体验。"), _c('br'), _vm._v(" 通过懂窝线下店，您可以亲临有温度的加减乘除空间，通过场景化沉浸式体验，实地触摸、挑选心仪的产品，"), _c('br'), _vm._v("同时收获更多灵感启发；门店未展示的商品可通过懂窝天猫店和懂窝微信小程序轻松在线浏览，"), _c('br'), _vm._v("让您更便捷地拥有心仪的家居好物。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module10"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("懂窝线下体验店")]), _c('div', {
    staticClass: "cont"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/img14.png")
    }
  }), _c('img', {
    attrs: {
      "src": require("assets/index/img15.png")
    }
  })]), _c('div', {
    staticClass: "address"
  }, [_vm._v("懂窝上海世博店 | 望达路1号B3-C 103")]), _c('div', {
    staticClass: "cont"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/img20.jpg")
    }
  }), _c('img', {
    attrs: {
      "src": require("assets/index/img21.png")
    }
  })]), _c('div', {
    staticClass: "address"
  }, [_vm._v("懂窝上海南丰城店 | 长宁区遵义路100号虹桥南丰城南区L218")]), _c('div', {
    staticClass: "cont"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/img22.png")
    }
  }), _c('img', {
    attrs: {
      "src": require("assets/index/img23.png")
    }
  })]), _c('div', {
    staticClass: "address"
  }, [_vm._v("懂窝上海LaLaport店 | 浦东新区新金桥路738号LaLaport 405&406")]), _c('div', {
    staticClass: "cont"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/img24.jpg")
    }
  }), _c('img', {
    attrs: {
      "src": require("assets/index/img25.png")
    }
  })]), _c('div', {
    staticClass: "address"
  }, [_vm._v("懂窝上海万象城店 | 闵行区吴中路1599号万象城L533")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module11"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("懂窝电商渠道")]), _c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("一键购买心仪好物")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("足不出户 体验便捷")]), _c('div', {
    staticClass: "code-box"
  }, [_c('img', {
    attrs: {
      "src": require("assets/index/img17.png")
    }
  }), _c('p', [_vm._v("扫码进入"), _c('br'), _vm._v(" 懂窝天猫店")]), _c('img', {
    attrs: {
      "src": require("assets/index/img18.png")
    }
  }), _c('p', [_vm._v("扫码进入"), _c('br'), _vm._v(" 懂窝小程序")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module12"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("品牌合作伙伴")]), _c('div', {
    staticClass: "border"
  }), _c('img', {
    attrs: {
      "src": require("assets/index/img19.jpg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b46e488"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = 439
// module chunks = 0